import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjayAvatar } from '../../DjayAvatar';
export function ThreeSubjectsIllustration({
  achievementId,
  variant = 'frost',
  // Unlocks frost variant
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-3642">
      <div className="relative w-full h-full bg-gradient-to-b from-sky-200 to-blue-400 overflow-hidden" data-id="element-3643">
        {/* Background: 3 Pillars */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3644">
          {/* Left Pillar */}
          <rect x="20" y="80" width="30" height="120" fill="#BAE6FD" data-id="element-3645" />
          <rect x="25" y="80" width="10" height="120" fill="#E0F2FE" data-id="element-3646" />
          <polygon points="20,80 50,80 35,60" fill="#7DD3FC" data-id="element-3647" />

          {/* Right Pillar */}
          <rect x="150" y="80" width="30" height="120" fill="#BAE6FD" data-id="element-3648" />
          <rect x="155" y="80" width="10" height="120" fill="#E0F2FE" data-id="element-3649" />
          <polygon points="150,80 180,80 165,60" fill="#7DD3FC" data-id="element-3650" />

          {/* Center Pillar (Behind Djay) */}
          <rect x="80" y="120" width="40" height="80" fill="#7DD3FC" data-id="element-3651" />
          <rect x="85" y="120" width="15" height="80" fill="#BAE6FD" data-id="element-3652" />
          <polygon points="80,120 120,120 100,100" fill="#38BDF8" data-id="element-3653" />
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-end justify-center pb-[10%]" data-id="element-3654">
          <div className="w-[65%] h-[65%] flex items-center justify-center" data-id="element-3655">
            <DjayAvatar size="hero" emotion={isUnlocked ? 'celebrating' : 'pointing'} variant={variant} accessory="tripleStars" animate={animate && isUnlocked} className="w-full h-full" data-id="element-3656" />
          </div>
        </div>

        {/* Foreground: Frost/Magic effects */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3657">
            <circle cx="35" cy="50" r="8" fill="#FDE047" opacity="0.8" filter="blur(2px)" data-id="element-3658" />
            <circle cx="165" cy="50" r="8" fill="#FDE047" opacity="0.8" filter="blur(2px)" data-id="element-3659" />
            <circle cx="100" cy="90" r="10" fill="#FDE047" opacity="0.6" filter="blur(3px)" data-id="element-3660" />

            <path d="M35 40 L35 60 M25 50 L45 50" stroke="white" strokeWidth="2" data-id="element-3661" />
            <path d="M165 40 L165 60 M155 50 L175 50" stroke="white" strokeWidth="2" data-id="element-3662" />
          </svg>}
      </div>
    </DjayIllustrationBase>;
}